import style from './index.module.css';
import React, { useState, useEffect } from 'react';
import { getBasketItems, removeFromBasket, updateBasketQuantity } from '../../services/BasketService';
import { checkoutBasket } from '../../services/BasketService';
const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBasketProducts();
  }, []);

  const fetchBasketProducts = async () => {
    setLoading(true);
    try {
      const data = await getBasketItems(); 
      setProducts(data); 
    } catch (error) {
      console.error("Error fetching basket products:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (productId) => {
    try {
      await removeFromBasket(productId); 
      setProducts(products.filter((item) => item.productId !== productId)); 
    } catch (error) {
      console.error("Error removing product:", error);
    }
  };

  const handleIncrease = async (productId) => {
    try {
      const userId = localStorage.getItem("userId"); 

      const updatedProducts = products.map((item) => {
        if (item.productId === productId) {
          return { ...item, quantity: item.quantity + 1 };
        }
        return item;
      });
      setProducts(updatedProducts);

      await updateBasketQuantity(userId, productId, 1); 
    } catch (error) {
      console.error("Məhsul sayını artırarkən xəta:", error);
    }
  };
  
  const handleDecrease = async (productId, quantity) => {
    try {
      const userId = localStorage.getItem("userId"); 

      if (quantity === 1) {
        await handleRemove(productId); 
      } else {
        const updatedProducts = products.map((item) => {
          if (item.productId === productId) {
            return { ...item, quantity: item.quantity - 1 };
          }
          return item;
        });
        setProducts(updatedProducts);

        await updateBasketQuantity(userId, productId, -1); 
      }
    } catch (error) {
      console.error("Məhsul sayını azaldarkən xəta:", error);
    }
  };

  const calculateSubTotal = () => {
    return products.reduce((total, item) => total + item.productPrice * item.quantity, 0).toFixed(2);
  };

  const handleCheckout = async () => {
    const userId = localStorage.getItem('userId'); 
    try {
      const orderData = await checkoutBasket(userId);
      alert('Sifariş uğurla tamamlandı!');
      console.log(orderData);

      setProducts([]); 
    } catch (error) {
      alert('Sifariş zamanı xəta baş verdi');
      console.error(error);
    }
  };

  if (loading) {
    return <p>Loading products...</p>;
  }

  return (
    <div>
      <div className={style.wish}>
        <h3>Cart Review</h3>
        <div className={style.wish1}>
          <p className={style.pr}>Product</p>
          <p className={style.unit}>Unit Price</p>
          <p>In Stock</p>
        </div>
        {products.length === 0 ? (
          <p>Your basket is empty.</p>
        ) : (
          products.map((item) => (
            <div className={style.product} key={item.productId}>
              <div className={style.div1}>
                <button onClick={() => handleRemove(item.productId)}>x</button>
              </div>
              <div className={style.div2}>
                <div className={style.img}>
                  <img src={item?.productPhoto} alt={item.productName} />
                </div>
                <div className={style.text}>
                  <p>{item.productName}</p>
                </div>
              </div>
              <div className={style.div3}>
                <p>${item.productPrice.toFixed(2)}</p>
              </div>
              <div className={style.div4}>
                <p>In Stock</p>
              </div>
              <div className={style.div5}>
                <span className={style.span1} onClick={() => handleDecrease(item.productId, item.quantity)}>-</span>
                <p>{item.quantity}</p>
                <span className={style.span2} onClick={() => handleIncrease(item.productId)}>+</span>
              </div>
            </div>
          ))
        )}
      </div>
      <div className={style.total}>
        <p>SubTotal: ${calculateSubTotal()}</p>
        <div className={style.button}>
          <button onClick={handleCheckout}>Checkout</button>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
